import requestAction from '../../utils/requestAction'

export const fetchPrepayments = (params: string) => 
  requestAction('PREPAYMENT_LIST', params)(`prepayments`, 'GET')
